function r(r,e){return Object.fromEntries(Array.from(new Map(e.map((e=>[e[r],e])))))}function e(r,e){return e.reduce(((e,n)=>({...e,[n[r]]:[...e[n[r]]??[],n]})),{})}export{e as groupBy,r as keyBy};
